import { render, staticRenderFns } from "./scanningSettings.vue?vue&type=template&id=1f412acc&"
import script from "./scanningSettings.vue?vue&type=script&lang=js&"
export * from "./scanningSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports